import React from 'react';

import { Box} from '@mui/material';
import { Container } from '@mui/material';

import UpdateInspectionAgencyHQForm from '../Components/UpdateInspectionAgencyHQForm';

export default function UpdateInspectionAgencyPage() {
  return (
    <Box>
      {/* UpdateInspectionAgencyPage */}
      <Container>
        <UpdateInspectionAgencyHQForm/>
      </Container>
    </Box>
  )
}
